<template>
    <!-- Cart wrap -->
    <div id="kosik" class="inner">
        <div class="OrderProcess">
            <div class="OrderProcess__item">
                <a :href="cartRoute">
                    <span class="OrderProcess__item-number active">1</span>{{ i18n.nakupny_kosik }}
                </a>
            </div>
          <div
              class="OrderProcess__item disabled is-hidden-mobile"
          ><span class="OrderProcess__item-number">2</span>{{ i18n.osobne_udaje }}
          </div>
            <div
                class="OrderProcess__item disabled"
            ><span class="OrderProcess__item-number">3</span>{{ i18n.doprava_a_platba }}
            </div>
            <div
                class="OrderProcess__item disabled is-hidden-mobile"
            ><span class="OrderProcess__item-number">4</span>{{ i18n.zhrnutie_objednavky }}
            </div>
        </div>
        <div class="cart-wrap">
            <div class="py-4" v-for="item in cart_items" :key="item.id">
                <CartRowComponent :item="item" :product-route="productRoute"></CartRowComponent>
            </div>
            <template v-if="cart.getCount()">
                <hr class="cart-hr">
				<div class="columns is-multiline is-mobile">
					<div class="column is-full-tablet is-full-mobile">
						<div class="mb-2">
							<h1>
								<b>{{ i18n['Zľavový kód'] }}</b>
							</h1>
						</div>
						<div class="columns" v-if="! appliedVoucher">
							<div class="column is-half-tablet">
								<div class="form-input">
									<input type="text" v-model="voucherCode" placeholder="Zľavový kód" class="form-input-element" :class="{'invalid-form-input-element': cartErrors['voucher']}">
									<small class="invalid-form-input-message" v-if="cartErrors['voucher']">
										{{ cartErrors['voucher'][0] }}
									</small>
								</div>
							</div>
							<div class="column is-half-tablet">
								<button type="button" @click="applyVoucher" class="button button--green checkout-button">{{ i18n['Uplatniť'] }}</button>
							</div>
						</div>
						<div class="columns" v-else>
							<div class="column is-half-tablet has-text-centered-mobile">
								<div>
									<b>{{ appliedVoucher.code }}</b>
								</div>
								<div v-if="appliedVoucher.apply_on_selected_products">
									<small>{{ i18n['Zľava je aplikovaná na vybrané produkty'] }}</small>
								</div>
							</div>
							<div class="column is-half-tablet has-text-centered-mobile has-text-right-tablet">
								<button type="button" @click="removeVoucher" class="button button--red button-small">{{ i18n.odstranit }}</button>
							</div>
						</div>
					</div>
				</div>
                <div class="text-right">
                    <h2 class="cart-heading cart-heading--green mt-4">{{ i18n.k_uhrade + ':' }} {{cart.getPriceFormatted()}}</h2>
                </div>
                <div class="columns mt-6 is-vcentered">
                    <div class="column is-half-tablet is-full-mobile  has-text-centered-mobile has-text-left-tablet">
                        <a :href="envishopRoute" class="button button--blue">{{ i18n.spat_k_nakupu }}</a>
                    </div>
                    <div class="column is-half-tablet is-full-mobile has-text-centered-mobile has-text-right-tablet">
                        <a :href="personalDetailsRoute"
                           class="button ">{{ i18n.pokracovat }}</a>
                    </div>
                </div>
            </template>
            <div class="text-center" v-else>
                <br>
                <p>{{ i18n.vas_kosik_je_prazdny }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import cart from "../cart";
    import CartRowComponent from "./CartRowComponent";

    export default {
        components: {
            CartRowComponent
        },
        props: {
          	cartRoute: String,
          	envishopRoute: String,
          	personalDetailsRoute: String,
          	productRoute: String,
        },
        data: function () {
            return {
                cart: cart,
                i18n: i18n,
				appliedVoucher: null,
				voucherCode: '',
				cartErrors: {}
            };
        },
        computed: {
            cart_items() {
                return this.cart.getItems();
            },
        },
        mounted() {
			this.getAppliedVoucher()
        },
        methods: {
            async addToCart(id, quantity = 1) {
                try {
                    await this.cart.addItem(id, quantity);
                } catch (e) {
                    throw e;
                }
            },
            removeFromCart(id) {
                this.cart.removeItem(id);
            },
            removeItemsFromCart(id) {
                this.cart.removeItems(id);
            },
			applyVoucher() {
				axios.post('/academy/apply-voucher', {
					voucher: this.voucherCode
				}).then(response => {
					this.appliedVoucher = response.data
					this.voucherCode = ''

					this.cart.update()

					this.cartErrors = {}
				}).catch(error => {
					this.cartErrors = error.response.data.errors
				})
			},
			removeVoucher() {
				axios.post('/academy/remove-voucher')
				.then(response => {
					this.cart.update()

					this.appliedVoucher = null
					this.voucherCode = ''

					this.cartErrors = {}
				}).catch(error => {

				})
			},
			async getAppliedVoucher() {
				await axios.get('/academy/applied-voucher').then(response => {
					this.appliedVoucher = response.data
				})
			}
        }
    };
</script>

<style scoped>
    .button--count {
        line-height: .4;
    }
</style>
